import {html, css, TemplateResult, CSSResultGroup} from 'lit'
import {customElement, property} from 'lit/decorators.js'
import {BaseComponent} from '../base-component.js'

@customElement('il-card-footer')
export default class CardFooterComponent extends BaseComponent {
  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      .il-card-footer {
        display: flex;
        justify-content: space-between;
        color: var(--il-color-accent-300);
        font-size: var(--il-font-size-16);
        font-weight: var(--il-font-weight-xbold);
        line-height: var(--il-font-line-height-150);
        letter-spacing: var(--il-font-letter-spacing-2);
      }
    `,
  ]

  @property({attribute: 'extra-footer', type: String})
  extraFooter: string = ''

  extraComponent (): TemplateResult {
    if (this.extraFooter) {
      return html` <div
        class="il-card-footer__extra"
        data-test-iliad-card-footer-extra
      >
        ${this.extraFooter}
      </div>`
    }

    return html``
  }

  override render (): TemplateResult {
    return html`
      <div
        class="${this.baseCSSClass} il-card-footer"
        data-test-iliad-card-footer
      >
        <slot></slot>
        ${this.extraComponent()}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'il-card-footer': CardFooterComponent
  }
}
